import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '@/globalStyles';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
import { STROKE_DASHARRAY, STROKE_WIDTH } from '@/constants';

const MaterialInfoBox = props => {
  const { transform } = props;
  const shieldsSelection = useSelector(state => state.core.shieldsSelection);
  const sectionsSelection = useSelector(state => state.core.sectionsSelection);
  const areShieldsSelected = !!Object.keys(shieldsSelection).length;
  const areSectionsSelected = !!Object.keys(sectionsSelection).length;
  const matfileTemplate = getBuildedMatfileTemplate();
  const isMatfileTemplateAvailable = !!matfileTemplate;

  if (areShieldsSelected || areSectionsSelected || !isMatfileTemplateAvailable) {
    return null;
  }

  const {
    box: { r: width, b: height },
  } = matfileTemplate;
  const materialFileName = matfileTemplate.name || matfileTemplate.file_name || '-';
  const tenPercentHeight = (height * 10) / 100;
  const rectHeight = tenPercentHeight / parseFloat((height / width).toFixed(1));
  const a = rectHeight / 2;
  const b = a % 2 === 0 ? a : rectHeight;
  const rectY = -(rectHeight + b);
  const textX = width / 2;
  const textY = -(rectHeight + b - rectHeight / 2);
  const textFontSize = (rectHeight * 33) / 100;

  return (
    <g id="material-info-box" transform={transform}>
      <rect
        x="0"
        y={rectY}
        width={width}
        height={rectHeight}
        fill={colors.white}
        stroke={colors.lightShadeGray}
        strokeWidth={STROKE_WIDTH}
        strokeDasharray={STROKE_DASHARRAY}
        rx={0.3}
      />
      <text x={textX} y={textY} alignmentBaseline="central" textAnchor="middle" fontSize={textFontSize} fontFamily="IBMPlexSans" fill="#a6a6a6">
        {materialFileName}
      </text>
    </g>
  );
};

export default MaterialInfoBox;
